export const __ACCESS_TOKEN_SUBLOS__ = '__ACCESS_TOKEN_SUBLOS__'

export const __SUBLOS_USER_DATA__ = '__SUBLOS_USER_DATA__'

export const __SUBLOS_ERROR__ = '__SUBLOS_ERROR__'

export const __SUBLOS_PERSIST_VALIDATION__ = '__SUBLOS_PERSIST_VALIDATION__'
